import { format, isValid } from 'date-fns'

/**
 * Форматирует дату обновления страницы в `dd.MM.yyyy`, как `dt_update|date:'d.m.Y'` в legacy.
 */
export default function formatDtUpdate(value?: string): string | undefined {
  if (!value) {
    return undefined
  }

  const date = new Date(value)

  if (!isValid(date)) {
    return undefined
  }

  return format(date, 'dd.MM.yyyy')
}
